import { Tooltip } from "@client/components/utils/Tooltip";
import { useLocalStorage } from "@uidotdev/usehooks";

export const RECENT_PROPOSALS_KEY = "recentProposals";
export const RECENT_PROPOSALS_LIMIT = 5;

export function pushRecentProposal(id: string) {
  try {
    const raw = localStorage.getItem(RECENT_PROPOSALS_KEY);
    const arr = raw ? (JSON.parse(raw) as string[]) : [];
    const newArr = [id, ...arr.filter((i) => i !== id)];
    if (newArr.length > RECENT_PROPOSALS_LIMIT)
      newArr.length = RECENT_PROPOSALS_LIMIT;
    localStorage.setItem(RECENT_PROPOSALS_KEY, JSON.stringify(newArr));
  } catch {
    // ignore
  }
}

export function useRecentProposalIndex(id: string): number {
  const [list] = useLocalStorage<string[]>(RECENT_PROPOSALS_KEY, []);
  return list.indexOf(id);
}

export function RecentIndicator({ proposalId }: { proposalId: string }) {
  const index = useRecentProposalIndex(proposalId);
  if (index < 0) return null;
  const intensity = 1 - index / RECENT_PROPOSALS_LIMIT;
  return (
    <Tooltip title="Recently reviewed">
      <span className="ml-1" style={{ opacity: intensity }}>
        ★
      </span>
    </Tooltip>
  );
}
